/** Default docx filename for exported Matter artifacts. */
export function generateDefaultDocxFilename(name: string | null): string {
  const timestamp = new Date().toISOString().slice(0, 16).replace('T', '_').replace(':', '')
  return name ? `${name} - ${timestamp}.docx` : `Untitled Document - ${timestamp}.docx`
}
